import React, { useMemo } from 'react';
import { Layout, Tabs } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';

const { Header: AntHeader } = Layout;

const getTabFromSearch = (search, allowed, fallback) => {
  const tab = new URLSearchParams(search || '').get('tab');
  return allowed.includes(tab) ? tab : fallback;
};

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const headerMode = useMemo(() => {
    if (location.pathname.startsWith('/content')) return 'content';
    if (location.pathname.startsWith('/timedPublish')) return 'timed';
    if (location.pathname.startsWith('/produce')) return 'produce';
    return null;
  }, [location.pathname]);

  const activeTabKey = useMemo(() => {
    if (headerMode === 'content') {
      return getTabFromSearch(location.search, ['raw', 'published'], 'raw');
    }
    if (headerMode === 'timed') {
      return getTabFromSearch(location.search, ['publish', 'produce'], 'publish');
    }
    if (headerMode === 'produce') {
      return getTabFromSearch(
        location.search,
        ['papers_to_notes', 'papers_to_video', 'papers_to_wechat_article', 'xhs_video_importer', 'weixin_channels_video_importer', 'video_bilingual_convert', 'idea_to_video'],
        'papers_to_notes',
      );
    }
    return null;
  }, [headerMode, location.search]);

  const tabItems = useMemo(() => {
    if (headerMode === 'content') {
      return [
        { key: 'raw', label: '原始内容' },
        { key: 'published', label: '已发布内容' },
      ];
    }
    if (headerMode === 'timed') {
      return [
        { key: 'produce', label: '生产任务' },
        { key: 'publish', label: '发布任务' },
      ];
    }
    if (headerMode === 'produce') {
      return [
        { key: 'papers_to_notes', label: '论文→小红书笔记' },
        { key: 'papers_to_video', label: '论文→短视频' },
        { key: 'papers_to_wechat_article', label: '论文→公众号文章' },
        { key: 'xhs_video_importer', label: '小红书抓取→视频导入' },
        { key: 'weixin_channels_video_importer', label: '视频号视频导入' },
        { key: 'video_bilingual_convert', label: '视频双语转换' },
        { key: 'idea_to_video', label: '创意→AI视频' },
      ];
    }
    return [];
  }, [headerMode]);

  const handleTabChange = (key) => {
    const params = new URLSearchParams(location.search || '');
    params.set('tab', key);
    if (headerMode === 'content') {
      navigate({ pathname: '/content', search: params.toString() });
      return;
    }
    if (headerMode === 'timed') {
      navigate({ pathname: '/timedPublish', search: params.toString() });
      return;
    }
    if (headerMode === 'produce') {
      navigate({ pathname: '/produce', search: params.toString() });
    }
  };

  return (
    <AntHeader
      style={{
        background: '#fff',
        padding: '0 12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
        {activeTabKey && (
          <Tabs
            className="tabs-only"
            activeKey={activeTabKey}
            onChange={handleTabChange}
            size="small"
            items={tabItems}
            tabBarStyle={{ margin: 0 }}
          />
        )}
      </div>
    </AntHeader>
  );
};

export default Header;
